import React from 'react';
import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Radio,
    RadioGroup,
    Typography,
    makeStyles,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useGetLeverandorTypesQuery } from '../../../services/rtkApi';
import { LocalLoader } from '@klp/design/Loader';

const useStyles = makeStyles((theme) => ({
    formField: {
        '& .MuiTypography-root': {
            color: theme.palette.text.primary,
        },
        '& .Mui-disabled': {
            cursor: 'not-allowed',
        },
        '& .MuiFormLabel-asterisk': {
            color: theme.palette.error.main,
            fontSize: '1.5rem',
        },
    },
}));

type LeverandorTypeSelectProps = {
    value?: string;
    touched?: boolean;
    error?: string;
    onChange: (value: string) => void;
};

export const LeverandorTypeSelect: React.FC<LeverandorTypeSelectProps> = ({
    value,
    touched,
    error,
    onChange,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { data: leverandorTypes, isLoading } = useGetLeverandorTypesQuery();

    const handleLeverandorTypeChange = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        onChange(event.target.value);
    };

    return (
        <LocalLoader isLoading={isLoading}>
            <FormControl
                component="fieldset"
                error={touched && !!error}
                fullWidth={true}
                margin="normal"
                required={true}
            >
                <FormLabel component="legend" className={classes.formField}>
                    {t('leverandor.createLeverandor.type.label')}
                </FormLabel>
                <RadioGroup
                    row={true}
                    value={value ?? ''}
                    onChange={handleLeverandorTypeChange}
                >
                    {leverandorTypes?.map((type) => (
                        <FormControlLabel
                            key={type}
                            value={type}
                            control={<Radio />}
                            label={t(
                                `leverandor.createLeverandor.type.${type.toLowerCase()}`,
                            )}
                        />
                    ))}
                </RadioGroup>
                {touched && error && (
                    <FormHelperText>{t(error)}</FormHelperText>
                )}
                {value?.toLowerCase() === 'engangsleverandor' && (
                    <Typography variant="body2" color="textSecondary">
                        {t(
                            'leverandor.createLeverandor.type.engangsleverandorInfo',
                        )}
                    </Typography>
                )}
            </FormControl>
        </LocalLoader>
    );
};
